import { render, staticRenderFns } from "./SideNavigationBar.vue?vue&type=template&id=62843964&scoped=true&"
import script from "./SideNavigationBar.vue?vue&type=script&lang=js&"
export * from "./SideNavigationBar.vue?vue&type=script&lang=js&"
import style0 from "./SideNavigationBar.vue?vue&type=style&index=0&id=62843964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62843964",
  null
  
)

export default component.exports